import styled from 'styled-components'

const NewsContainerStyle = styled.section`
    /* &:after{
        content:'';
        position: absolute;
        bottom: 0;
        left: 0;
        width:100%;
        height: 3px;
        background-color: var(--backColor);
    } */
`
export default NewsContainerStyle
